import { z } from 'zod';

/**
 * Loose identification schema for a pre-versioning spacer: the widget name is the
 * only proof of kind. Everything else is coerced by the migration rather than
 * validated here, so a persisted spacer with a string or `null` height still lifts
 * to v0 instead of failing to match.
 */
export const indentLegacyShapeSchema = z.looseObject({
    name: z.literal('indent'),
});
